import React, { useState, useMemo } from "react"

import { useImage } from "../../../hooks/useImage"

export const withTestimonials = Component => ({ name = "Testimonials", id, items: rawItems }) => {
  const { getResponsiveImage } = useImage()
  const [image, setImage] = useState(0)

  const handleInit = (slides: any) => {
    setTimeout(() => {
      slides.update()
    }, 300)
  }

  const handleSlideChange = (slides: any) => {
    setImage(slides.realIndex)
  }

  const items = rawItems?.map((item: any) => ({
    ...item,
    image: getResponsiveImage(item?.image, { maxWidth: 2000 }),
    key: item?._key,
  }))

  const length = useMemo(() => items?.length > 1, [items?.length])

  Component.displayName = name
  return <Component id={id} image={image} items={items} handleInit={handleInit} handleSlideChange={handleSlideChange} length={length} />
}
